import React, { useEffect, useState } from 'react';
import { useQuery, useApolloClient, gql } from '@apollo/client';
import useStyles from 'isomorphic-style-loader/useStyles';

import CssImpersonationBanner from './ImpersonationBanner.scss';

export const IMPERSONATION_STATUS_QUERY = gql`
  query ImpersonationStatus {
    ImpersonationStatus {
      active
      impersonatedUser {
        id
        email
        display_name
      }
      originalUser {
        id
        email
        display_name
      }
    }
  }
`;

const ImpersonationBanner = () => {
  useStyles(CssImpersonationBanner);
  const apolloClient = useApolloClient();
  const [stopping, setStopping] = useState(false);
  const { data } = useQuery(IMPERSONATION_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    ssr: false,
  });

  const status = data && data.ImpersonationStatus;
  const active = !!(status && status.active && status.impersonatedUser);

  useEffect(
    () => {
      if (typeof document === 'undefined') return undefined;
      if (active) {
        document.body.classList.add('impersonation-active');
      } else {
        document.body.classList.remove('impersonation-active');
      }
      return () => {
        document.body.classList.remove('impersonation-active');
      };
    },
    [active],
  );

  if (!active) return null;

  const handleStop = async () => {
    if (stopping) return;
    setStopping(true);
    try {
      await fetch('/login/impersonate/stop', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.warn('Failed to stop impersonation via API', err);
    }
    try {
      await apolloClient.clearStore();
    } catch (err) {
      console.warn('Failed to clear Apollo store on stop', err);
    }
    window.location.assign('/admin-panel/impersonate');
  };

  const { display_name: displayName, email } = status.impersonatedUser;

  return (
    <div className="impersonation-banner" role="status" aria-live="polite">
      <span className="impersonation-banner__text">
        You are currently impersonating{' '}
        <strong>
          &quot;{displayName}&quot; ({email})
        </strong>
      </span>
      <button
        type="button"
        className="impersonation-banner__button"
        onClick={handleStop}
        disabled={stopping}
      >
        {stopping ? 'Stopping…' : 'Stop impersonating'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
